var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { MdInsertDriveFile } from 'react-icons/md';
import { Flex, Text, Spinner, Icon } from "./..";
import { FileUploadInput } from './FileUploadInput';
var handleDragAndDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
};
var DefaultIcon = function () { return (React.createElement(Icon, { as: MdInsertDriveFile, size: 60, lss: { color: 'emerald500' } })); };
export var FileUploader = function (_a) {
    var onFileSelection = _a.onFileSelection, isUploading = _a.isUploading, id = _a.id, _b = _a.fileIcon, FileIcon = _b === void 0 ? DefaultIcon : _b, _c = _a.dragLabel, dragLabel = _c === void 0 ? 'Drag & Drop File Here' : _c, _d = _a.selectLabel, selectLabel = _d === void 0 ? 'Select File to Upload' : _d, acceptedFileTypes = _a.acceptedFileTypes;
    var _e = __read(useState(), 2), fileIsInDragArea = _e[0], setFileIsInDragArea = _e[1];
    return (React.createElement(Flex, { id: id ? id + "-drag-and-drop-upload" : 'drag-and-drop-upload', lss: {
            mt: 'md',
            flexDirection: 'column',
            width: '100%',
            height: '40vh',
            justifyContent: 'center',
            alignItems: 'center',
            bg: fileIsInDragArea ? 'turquoise200' : 'gray100',
            border: 'regular',
            borderStyle: 'dashed',
            borderRadius: 'md',
            transition: 'slow'
        }, onDragEnter: function (e) {
            handleDragAndDrop(e);
            setFileIsInDragArea(true);
        }, onDragOver: function (e) {
            handleDragAndDrop(e);
            setFileIsInDragArea(true);
        }, onDragLeave: function (e) {
            handleDragAndDrop(e);
            setFileIsInDragArea(false);
        }, onDrop: function (e) {
            var file = e.dataTransfer.files[0];
            handleDragAndDrop(e);
            onFileSelection(file);
            setFileIsInDragArea(false);
        } },
        isUploading ? React.createElement(Spinner, null) : React.createElement(FileIcon, null),
        React.createElement(Text, { as: "h3", lss: { fontSize: 'heading4', mt: 'lg', mb: 'xs' } }, dragLabel),
        React.createElement(FileUploadInput, { id: id, accept: acceptedFileTypes, onFileSelection: onFileSelection, label: selectLabel })));
};
//# sourceMappingURL=FileUploader.js.map